import React, { useEffect, useState } from "react";
import columns from "../../../columns/activity/activity";
import moment from "moment";
import { GetActivityApi } from "../../../api/request/activity/activity";
import SkeletonTable from "../../../components/table/SkeletonTable";

const Activity = ({ id }) => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const getActivity = async () => {
    try {
      setIsLoading(true);
      const { data } = await GetActivityApi({ user_id: id });
      setData(
        data?.data?.map((item) => {
          return {
            ...item,
            created_at: item?.created_at
              ? moment(item?.created_at).format("lll")
              : "--",
          };
        })
      );
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getActivity();
  }, []);

  return (
    <div className="bg-white">
      <div className="flex justify-between mx-5 mt-5">
        <p className=" sub-title text-2xl">Activity</p>
      </div>

      <div className="mt-5">
        <SkeletonTable
          columns={columns}
          data={data}
          isLoading={isLoading}
          pagination={true}
        />
      </div>
    </div>
  );
};

export default Activity;
